import * as types from '../../actionTypes';

export const displayModal = payload => ({
  type: types.DISPLAY_DUPLICATE_MODAL,
  payload,
});

export const hideModal = () => ({
  type: types.HIDE_DUPLICATE_MODAL,
});

export const setData = payload => ({
  type: types.SET_DUPLICATE_MODAL_DATA,
  payload,
});
